import { useKnockFeed } from '@knocklabs/react-notification-feed'
import React from 'react'
import styled from 'styled-components'
import { Text } from 'lib/Text'

const NotificationCount = styled(Text)`
  align-items: center;
  background: red;
  border-radius: 10px;
  border: 1px solid white;
  display: flex;
  font-style: normal;
  justify-content: center;
  line-height: 17px;
  padding: 0 8px;
  position: absolute;
  right: 0;
  transform: translateX(50%) translateY(-12px);
  width: 16px;
`

export const UnreadNotificationsCounter = () => {
  const { useFeedStore } = useKnockFeed()
  const badgeCountValue = useFeedStore((state) => state.metadata.unseen_count)

  if (badgeCountValue >= 1) {
    return (
      <NotificationCount color="white" weight="bold" size="small">
        {badgeCountValue}
      </NotificationCount>
    )
  }

  return null
}
